<template>
  <div class="circle_navigation">
    <button v-on:click="goButton1" class="cn_button button_1" :class="{passed: button1passed, active:isButtonActive(1)}"
        :id="`tracking__${trackingCode}__progress-tracker__farm-details`" :disabled="button1disabled">
        <span class="number">1</span> 
        <span class="text">Farm details</span>   
    </button>
    <button v-on:click="goButton2" class="cn_button button_2" :class="{passed: button2passed, active:isButtonActive(2)}"
        :id="`tracking__${trackingCode}__progress-tracker__finance-details`" :disabled="button2disabled">
        <span class="number">2</span> 
        <span class="text">Finance details</span>   
    </button>
    <button v-on:click="goButton3" class="cn_button button_3" :class="{passed: button3passed, active:isButtonActive(3)}"
        :id="`tracking__${trackingCode}__progress-tracker__your-details`" :disabled="button3disabled">
        <span class="number">3</span> 
        <span class="text">Your details</span>   
    </button>
  </div>
</template>

<script>


export default {
  props: {
      step: {
          type: Number,
          default: 0
      },
  }, 
  data() {
    return {
        trackingCode: window.trackingCode
    };
  },
  computed: {
    button1disabled: function button1disabled(){
        return this.step === 2
    },
    button2disabled: function button2disabled(){
        return this.step === 3 || !this.button1passed
    },
    button3disabled: function button3disabled(){
        return this.step === 4 || !this.button2passed
    },
    button1passed: function button1passed(){
        return this.navData[0]
    },
    button2passed: function button2passed(){
        return this.navData[1]
    },
    button3passed: function button3passed(){
        return this.navData[2]
    },
    navData: function navData(){
        return this.$parent.$parent.circleNavData
    }
  },
  created: function(){
      if (this.step === 0) {
          this.showNextButton = true;
      }
      if (this.step === 1) {
          this.showNextButton = true;
      }
  },
  methods: {
      goButton1: function goButton1(){
          this.$emit('stepBack', this.step)
          this.$router.push({ name: 'farm-details' })
      },
      goButton2: function goButton2(){
          if (this.step === 4) {
            this.$emit('stepBack', this.step)
            this.$router.push({ name: 'finance-details' })
          }
          if (this.step === 2) {
            this.$emit('stepNext', this.step)
            this.$router.push({ name: 'finance-details' })
          }
      },
      goButton3: function goButton3(){
          this.$emit('stepNext', this.step)
          this.$router.push({ name: 'your-details' })
      },
      isButtonActive: function isButtonActive(numb) {
          return numb === this.step - 1
      }
  }
};
</script>